import { render, staticRenderFns } from "./RecommendedProceduresDetail.vue?vue&type=template&id=c78b5e68&scoped=true&"
import script from "./RecommendedProceduresDetail.vue?vue&type=script&lang=js&"
export * from "./RecommendedProceduresDetail.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedProceduresDetail.vue?vue&type=style&index=0&id=c78b5e68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c78b5e68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VOverlay,VProgressCircular,VRow})
